import { useState } from "react";
import { faqs, trustSteps } from "@/mocks/homeData";

export default function TrustFaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="rounded-lg bg-foreground-950 p-6 md:p-10">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <span className="flex items-center gap-2 font-label text-xs tracking-[0.28em] text-accent-400">
                <i className="ri-shield-check-line" />
                信任与整理流程
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                每一条更新，都是这样来的
              </h2>
            </div>
            <p className="max-w-md font-body text-sm leading-relaxed text-background-300">
              我们不生产内容，只负责把当天流出的动态按时间整理清楚，让蹲进展的人少翻几页。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
            {trustSteps.map((step, index) => (
              <div key={step.title} className="border-t border-background-700 pt-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-foreground-950">
                    <i className={step.icon} />
                  </span>
                  <span className="font-label text-xs text-background-500">STEP {index + 1}</span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-background-50">{step.title}</h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-background-300">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">常见问题</h3>
            <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
              关于更新频率、内容来源与转载说明，这里都写清楚了。还有别的疑问，可以在下方联系我们。
            </p>
            <a
              href="#footer"
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-mail-line" />
              联系与反馈
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-4 text-left"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-sm transition-colors ${
                          isOpen
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-300 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    {isOpen && (
                      <p className="pb-5 pr-10 font-body text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}